import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["name", "keyname", "visible", "tagName"];
import { useEffect, createElement, memo } from 'react';
import { useStore } from './store';
export var Block = /*#__PURE__*/memo(props => {
  var {
    blocks = {},
    dispatch
  } = useStore();
  var {
      name,
      keyname,
      visible = true,
      tagName = 'div'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  useEffect(() => {
    if (name || keyname) {
      var key = keyname || name;
      var div = visible ? /*#__PURE__*/createElement(tagName, _extends({}, elmProps), elmProps.children) : null;
      delete blocks[key];
      dispatch({
        blocks: _extends({}, blocks, {
          [key]: div
        })
      });
    }
  }, [props]);
  return null;
});
Block.displayName = 'Login.Block';